let initialized = false;

/**
 * Extend the native Number prototype with useful helpers we are using across the system.
 */
export const setupNumberExtensions = () => {
  if (initialized) {
    return;
  }

  Object.defineProperty(Number.prototype, 'format', {
    value(this: number, { locale = 'en-US', decimals }: NumberFormatOptions = {}) {
      const options: Intl.NumberFormatOptions = {};
      if (decimals !== undefined) {
        options.maximumFractionDigits = decimals;
        options.minimumFractionDigits = decimals;
      }

      return new Intl.NumberFormat([locale], options).format(this);
    },
    writable: false,
    enumerable: false,
  });

  Object.defineProperty(Number, 'parseId', {
    value(id: string | undefined | null): number | null {
      if (!id || !/^\d+$/.test(id)) {
        return null;
      }
      return parseInt(id, 10);
    },
    writable: false,
    enumerable: false,
  });

  initialized = true;
};
